import mermaid from "refractor/mermaid";
export default mermaid;